import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { WalletUserIndexResponse } from '@/repositories/generated';
import {
  WalletUserLockStatusKeys,
  WalletUserStatusKeys,
  WalletUserTypeKeys,
} from '@/types';

const content: WalletUserIndexResponse[] = WalletUserLockStatusKeys.flatMap((lockStatus) => (
  WalletUserStatusKeys.flatMap((status) => (
    WalletUserTypeKeys.map((userType) => ({
      lockStatus,
      status,
      userType,
    }))
  ))
))
  .map((p, index) => (
    {
      createdAt: '2022-01-15',
      email: 'test@example.com',
      externalUserId: `test_user_${index.toString()}`,
      issuerName: 'テストイシュア',
      lockStatus: p.lockStatus,
      phoneNumber: '00000000000',
      status: p.status,
      userType: p.userType,
      walletServiceName: 'テストウォレット',
      walletUserId: index.toString(),
    }
  ));

const loopContent = [...new Array<string>(50)].map((_, i) => content[i % content.length]);

export const walletUser = http.get(
  createMockEndpoint('/wallet_user'),
  async ({ request }) => {
    const url = new URL(request.url);
    await delay(500);
    const hasQueryParam = [
      'walletUserId',
      'externalUserIds',
      'statuses',
      'phoneNumber',
      'email',
      'createdAtStartDateTime',
      'createdAtEndDateTime',
      'lockStatuses',
      'issuerNames',
      'walletServiceNames',
      'withdrawalCode',
      'page',
      'size',
    ].some((it) => url.searchParams.getAll(it).length > 0);

    if (hasQueryParam) {
      return HttpResponse.json({
        content: loopContent.slice(3, 25),
        pageable: {
          sort: {
            empty: true,
            sorted: false,
            unsorted: true,
          },
          offset: 0,
          pageNumber: 0,
          pageSize: 20,
          paged: true,
          unpaged: false,
        },
        last: true,
        totalPages: 1,
        totalElements: 20,
        size: 20,
        number: 0,
        sort: {
          empty: true,
          sorted: false,
          unsorted: true,
        },
        first: true,
        numberOfElements: 20,
        empty: false,
      }, { status: 200 });
    }
    // クエリパラメータなし
    return HttpResponse.json({
      content: loopContent,
      pageable: {
        sort: {
          empty: true,
          sorted: false,
          unsorted: true,
        },
        offset: 0,
        pageNumber: 0,
        pageSize: 20,
        paged: true,
        unpaged: false,
      },
      last: true,
      totalPages: 1,
      totalElements: 50,
      size: 50,
      number: 0,
      sort: {
        empty: true,
        sorted: false,
        unsorted: true,
      },
      first: true,
      numberOfElements: 50,
      empty: false,
    }, { status: 200 });
  },
);
